import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackDropDownDto } from '.';



export class RackDropDownResponseModel extends GlobalResponseObject {
    data?: RackDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RackDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

